import React from 'react';


import * as styleUtils from '../../../../../utils/styleUtils';

import {I18nMessage} from '../../../../contexts/I18n';
import {assetUrl} from '../../../../../utils/cdnUtils';

import styles from './ServicesRow.scss';


function ServicesRow() {

    return (
        <section className={styleUtils.toClasses(styles.servicesRow)}>
            <div className={'container'}>

                <div className={'row'}>

                    <div className={'col-4'}>
                        <img
                            alt={''}
                            className={styles.moodImage}
                            height={120}
                            src={assetUrl('/images/openArchive.svg')}
                            width={204}
                        />
                        <h2>
                            <I18nMessage id={'page.start.static.services.headline1'}/>
                        </h2>
                        <p>
                            <I18nMessage id={'page.start.static.services.text1'}/>
                        </p>
                    </div>

                    <div className={'col-4'}>
                        <img
                            alt={''}
                            className={styles.moodImage}
                            height={120}
                            src={assetUrl('/images/variable.svg')}
                            width={192}
                        />
                        <h2>
                            <I18nMessage id={'page.start.static.services.headline2'}/>
                        </h2>
                        <p>
                            <I18nMessage id={'page.start.static.services.text2'}/>
                        </p>
                    </div>

                    <div className={'col-4'}>
                        <img
                            alt={''}
                            className={styles.moodImage}
                            height={120}
                            src={assetUrl('/images/trends.svg')}
                            width={206}
                        />
                        <h2>
                            <I18nMessage id={'page.start.static.services.headline3'}/>
                        </h2>
                        <p>
                            <span className={'display-block margin-bottom-10'}>
                                <span className={styles.corporateName}>
                                    <I18nMessage id={'corporate.name'}/>
                                </span>
                                <I18nMessage id={'page.start.static.services.text3-1'}/>
                            </span>

                            <span className={styles.corporateName}>
                                <I18nMessage id={'corporate.name'}/>
                            </span>
                            <I18nMessage id={'page.start.static.services.text3-2'}/>
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}


ServicesRow.propTypes = {};

ServicesRow.defaultProps = {};


export default ServicesRow;
